import { Activity } from '../../../lib/types/models/ol/activity/activity'
import { ActivityInput } from '../../../lib/types/models/ol/activity/activity-input'
import { OlRateIdInput } from '../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateActivity = async (data: Partial<ActivityInput> & OlRateIdInput) => {
  const { id, olId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.ols.updateActivity.url, { id, olId }))
    .patch<Activity, Partial<ActivityInput>>(rest)
}
